import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
import { urlMedia } from '../helpers/videosMedia';

const tipoMeta = {
    youtube: { label: 'YouTube', color: '#dc2626', icon: 'fa-brands fa-youtube' },
    video: { label: 'Video', color: '#2563eb', icon: 'fa-solid fa-film' },
    imagen: { label: 'Imagen', color: '#16a34a', icon: 'fa-solid fa-image' },
};

const Preview = ({ item }) => {
    const tipo = item.tipoMedia || 'youtube';

    if (tipo === 'imagen') {
        return (
            <img
                src={urlMedia(item.videoCodigo)}
                alt=""
                style={{ width: 64, height: 40, objectFit: 'cover', borderRadius: 6, border: '1px solid #e2e8f0' }}
                onError={(e) => { e.target.style.visibility = 'hidden'; }}
            />
        );
    }

    if (tipo === 'video') {
        return (
            <video
                src={urlMedia(item.videoCodigo)}
                muted
                preload="metadata"
                style={{ width: 64, height: 40, objectFit: 'cover', borderRadius: 6, border: '1px solid #e2e8f0' }}
            />
        );
    }

    return (
        <img
            src={`https://img.youtube.com/vi/${item.videoCodigo}/default.jpg`}
            alt=""
            style={{ width: 64, height: 40, objectFit: 'cover', borderRadius: 6, border: '1px solid #e2e8f0' }}
            onError={(e) => { e.target.style.visibility = 'hidden'; }}
        />
    );
};

export const ListaVideosDrop = ({ items, onDragEnd, handleInputChange, deleteItem }) => {

    return (
        <div className='container'>
            <div className=' p-3 mb-2 d-none d-md-none d-lg-block'>

                <div className='row '>

                    <div className='col-lg-1 col-12 text-center fw-bold'> Ítem </div>
                    <div className='col-lg-2 col-12 text-center fw-bold'> Tipo </div>
                    <div className='col-lg-3 col-12 text-center fw-bold'>Título </div>
                    <div className='col-lg-4 col-12 text-center fw-bold'>Código / Archivo </div>
                    <div className='col-lg-1 col-12 text-center fw-bold'> Duración </div>
                    <div className='col-lg-1 col-12 text-center fw-bold'> </div>

                </div>

            </div>
            <DragDropContext onDragEnd={onDragEnd}>
                <Droppable droppableId="list">
                {(provided) => (
                    <div
                        style={{ maxHeight: '600px', overflowY: 'auto', padding: '2em' }}
                        className='container rounded shadow p-3'
                        ref={provided.innerRef}
                        {...provided.droppableProps}
                    >
                        {items.map((item, index) => {
                            const tipo = item.tipoMedia || 'youtube';
                            const meta = tipoMeta[tipo] || tipoMeta.youtube;
                            const esArchivo = tipo === 'video' || tipo === 'imagen';

                            return (
                            <Draggable key={item.uidVideo} draggableId={item.uidVideo} index={index}  >
                            {(provided) => (
                                <div
                                className=" row bg-light p-3 shadow m-auto mb-2 align-items-center"
                                ref={provided.innerRef}
                                {...provided.draggableProps}
                                {...provided.dragHandleProps}
                                >
                                    <div className='col-lg-1 col-12 fw-bold mt-2'>
                                        { index+1 }
                                    </div>

                                    <div className='col-lg-2 col-12 mb-1 d-flex align-items-center gap-2'>
                                        <Preview item={item} />
                                        <span
                                            className='badge'
                                            style={{ backgroundColor: meta.color }}
                                        >
                                            <i className={`${meta.icon} me-1`}></i>{meta.label}
                                        </span>
                                    </div>

                                    <div className='col-lg-3 col-12 mb-1'>
                                        <label className=' d-lg-none d-md-block d-sm-block d-block' >
                                            Título
                                        </label>
                                            <input
                                                type="text"
                                                defaultValue={item.videoTitulo}
                                                className='form-control'
                                                onBlur={(ev) => handleInputChange(ev, 'videoTitulo', item.uidVideo)}
                                            />


                                    </div>

                                    <div className='col-lg-4 col-12 mb-1'>
                                        <label className=' d-lg-none d-md-block d-sm-block d-block' >
                                            {esArchivo ? 'Archivo' : 'Código'}
                                        </label>
                                        <input
                                            type="text"
                                            defaultValue={item.videoCodigo}
                                            className='form-control'
                                            readOnly={esArchivo}
                                            title={esArchivo ? 'Ruta del archivo subido (no editable)' : ''}
                                            onBlur={esArchivo ? undefined : (ev) => handleInputChange(ev, 'videoCodigo', item.uidVideo)}
                                        />

                                    </div>

                                    <div className='col-lg-1 col-12 mb-1'>
                                        <label className=' d-lg-none d-md-block d-sm-block d-block' >
                                            Seg.
                                        </label>
                                        {tipo === 'imagen' ? (
                                            <input
                                                type="number"
                                                min="1"
                                                defaultValue={item.duracionSeg || 10}
                                                className='form-control'
                                                title='Segundos que se muestra la imagen en pantalla'
                                                onBlur={(ev) => handleInputChange(ev, 'duracionSeg', item.uidVideo)}
                                            />
                                        ) : (
                                            <span
                                                className='text-muted small fst-italic d-block pt-2'
                                                title='Los videos se reproducen completos'
                                            >
                                                Completo
                                            </span>
                                        )}
                                    </div>

                                    <div className='col-lg-1 col-12 mt-1'>
                                        <button
                                            className='btn btn-sm btn-danger'
                                            onClick={() => deleteItem( item.uidVideo ) }
                                        >
                                        <i className='fa-solid fa-minus'></i>
                                        </button>
                                    </div>
                                </div>
                            )}
                            </Draggable>

                        );
                        })}
                    {provided.placeholder}
                    </div>
                )}
                </Droppable>
            </DragDropContext>
        </div>
    );
  };
